import React from 'react';
import "../style/AppPages.css"

const MediaContact = () => {
    return (
        <div class="page-padding-info">
            <div class="text-page-container">
                <h1 class="text-page-title">Press and Media</h1>

                <p>
                    &nbsp;
                    <strong>
                    Hi, please contact us at <a href="mailto:contact@awootoys.com">Contact@awootoys.com</a> for any inquiries. We hope we can answer any question you may have. You may also send any press and media inquiries to this address.
                    </strong>
                </p>
            </div>
        </div>
    );
}

export default MediaContact;